

export function showLoader(el) {
    el.classList.add("loader--visible");
}

export function hideLoader(el) {
    el.classList.remove("loader--visible");
}
